<template>
  <el-container class="app-container">
    <el-header v-if="isAuthenticated">
      <!-- Desktop menu -->
      <el-menu mode="horizontal" router class="desktop-menu" v-if="!isMobile">
        <div class="menu-items">
          <el-menu-item index="/" @click="resetOrderStep">
            <el-icon><DocumentAdd /></el-icon>
            Новый заказ
          </el-menu-item>
          <el-menu-item index="/orders">
            <el-icon><List /></el-icon>
            Мои заказы
          </el-menu-item>
          <el-menu-item index="/senders">
            <el-icon><User /></el-icon>
            Договоры с МНОС
          </el-menu-item>
        </div>
        <div class="user-info">
          <span class="user-email">{{ user?.email }}</span>
          <el-button link @click="handleLogout">Выйти из аккаунта</el-button>
        </div>
      </el-menu>
      
      <!-- Mobile menu -->
      <div class="mobile-menu" v-else>
        <el-row align="middle" justify="space-between">
          <el-col :span="4">
            <el-dropdown trigger="click">
              <el-button type="primary" circle>
                <el-icon><Menu /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="resetOrderStep">
                    <el-icon><DocumentAdd /></el-icon> Новый заказ
                  </el-dropdown-item>
                  <el-dropdown-item @click="router.push('/orders')">
                    <el-icon><List /></el-icon> Мои заказы
                  </el-dropdown-item>
                  <el-dropdown-item @click="router.push('/senders')">
                    <el-icon><User /></el-icon> Отправители
                  </el-dropdown-item>
                  <el-dropdown-item divided @click="handleLogout">
                    Выйти из аккаунта
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
          <el-col :span="20" class="mobile-user-info">
            <span class="user-email">{{ user?.email }}</span>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <router-view/>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { DocumentAdd, List, Menu, User } from '@element-plus/icons-vue'

export default defineComponent({
  name: 'App',
  components: {
    DocumentAdd,
    List,
    Menu,
    User
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const isMobile = ref(false)

    const checkScreenSize = () => {
      isMobile.value = window.innerWidth < 768
    }

    onMounted(() => {
      checkScreenSize()
      window.addEventListener('resize', checkScreenSize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize)
    })

    const isAuthenticated = computed(() => store.state.auth?.isAuthenticated)
    const user = computed(() => store.state.auth?.user)

    const handleLogout = async () => {
      await store.dispatch('auth/logout')
      router.push('/login')
    }

    const resetOrderStep = () => {
      store.commit('SET_ACTIVE_ORDER_STEP', 0)
      router.push('/order/new')
    }

    return {
      isAuthenticated,
      user,
      handleLogout,
      isMobile,
      router,
      resetOrderStep
    }
  }
})
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}

.app-container {
  height: 100%;
  width: 100%;
}

.el-header {
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.desktop-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.mobile-menu {
  padding: 10px 16px;
  width: 100%;
  box-sizing: border-box;
}

.mobile-user-info {
  text-align: right;
  padding-right: 10px;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-email {
  margin-right: 15px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-items {
  display: flex;
  align-items: center;
}

.el-main {
  margin: 0 auto;
  padding: 0 !important;
  box-sizing: border-box;
  width: 100%;
}

@media (max-width: 768px) {
  .el-main {
    padding: 0 !important;
  }
  
  :deep(.el-radio-button),
  :deep(.el-input-number) {
    width: 100%;
  }
  
  :deep(.el-radio-group) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>
